import aa from "search-insights";

aa("init", {
  appId: process.env.client_algolia_app_id,
  apiKey: process.env.client_algolia_search_key,
});

export const setAlgoliaAuthenticatedUser = (username: string) => {
  aa("setAuthenticatedUserToken", username);
};
